// Демо-форма подсказок по ФИО.

import helper from "../domain/name";
import createComponent from "../vue";
import SuggestionsService from "./service";
import Analytics from "../marketing/analytics";

const $ = window.jQuery;

const STATE = {
    fio: null,
    type: "NAME",
};

const service = new SuggestionsService("NAME");

const properties = {
    genderWithSign() {
        return helper.genderWithSign(this.fio);
    },

    good() {
        return helper.isGood(this.fio);
    },

    validationMessage() {
        return helper.validationMessage(this.fio);
    },
};

const methods = {
    initSuggestions(serviceUrl, token) {
        const $el = $(this.$refs.input);
        const params = {
            serviceUrl,
            token,
            type: this.type,
            count: 7,
            onSelect: this.onSelect,
            onSelectNothing: this.onSelectNothing,
        };
        $el.suggestions(params);
    },

    onSelect(suggestion) {
        Analytics.reachGoal("SUG_DEMO_FORM_NAME");
        this.fio = suggestion.data;
        service.enrich(suggestion.unrestricted_value, suggestion)
            .done(fio => {
                this.fio = fio;
            });
    },

    onSelectNothing(query) {
        if (!query) {
            this.fio = null;
            return;
        }
        const self = this;
        service.enrich(query)
            .done(fio => {
                self.fio = fio;
            });
    },
};

function buildConfig(serviceUrl, token) {
    return {
        data() { return STATE; },
        mounted() {
            this.$nextTick(() => this.initSuggestions(serviceUrl, token));
        },
        computed: properties,
        methods,
    };
}

export default function Suggestions(serviceUrl, token) {
    const nameConfig = buildConfig(serviceUrl, token);

    createComponent(nameConfig, "#name-vue-app");
}
